/* eslint-disable react/display-name */
import React from 'react'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { rowHeaderRender } from 'core/utils'
export const getTitle = id =>
  id === 'MONTH'
    ? 'Curr. Month'
    : id === '12MONTHS'
    ? 'Last 12 Mon.'
    : id === undefined
    ? ''
    : id

const getData = data => {
  return (data || []).map(d => {
    const val = parseFloat(d.displayContent)
    if (isNaN(val)) return d
    else return { ...d, displayContent: val + '' }
  })
}

export default ({ data, setting, idWidth, dtWidth, grWidth, grHeight }) => (
  <Grid
    headers={[
      strCol({
        ident: 'displayName',
        display:
          'KPI (' +
          (setting && setting.period ? getTitle(setting.period) : ' ') +
          ')',
        width: idWidth || 110,
        alignment: 'left',
        ellipsis: true,
      }),
      numCol({
        ident: 'displayContent',
        display: 'Value',
        width: dtWidth || 80,
        displayForamt: '0.####',
        alignment: 'center',
      }),
    ]}
    data={getData(data)}
    render={virtualizedGridRenderer({
      // autoFixColByKey,
      rowHeaderRender,
      height: grHeight || 200,
      width: grWidth || 180,
      headerRowHeight: 30,
    })}
    selectionType="row"
    selectionMode="single"
  />
)
